"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgQuoteSerif48 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 50, height: 48, viewBox: "0 0 50 48", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("path", { fill: "none", d: "M.75 0h48v48h-48z" }), (0, jsx_runtime_1.jsx)("path", { d: "M23.347 29.89c0 2.578-2.377 4.934-5.348 4.934-4.91 0-7.049-3.632-7.049-8.48 0-5.565 5.61-10.932 10.698-13.168l1.36 2.19c-4.193 2.031-7.327 4.786-7.772 9.405h1.735c1.858 0 3.787.3 5.076 1.634.918.954 1.3 2.167 1.3 3.485Zm15.203 0c0 2.578-2.377 4.934-5.348 4.934-4.91 0-7.049-3.632-7.049-8.48 0-5.565 5.61-10.932 10.698-13.168l1.36 2.19c-4.193 2.031-7.327 4.786-7.771 9.405 1.892 0 3.461-.069 4.86.432 2.177.779 3.25 2.462 3.25 4.687Z", fill: "currentColor" })] })) }))); };
exports.default = SvgQuoteSerif48;
